// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChatFooter__container-a49986 {
  background-color: var(--base-0);
  position: relative;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChatFooter/ChatFooter.styles.m.css"],"names":[],"mappings":"AAAA;EACE,+BAAA;EACA,kBAAA;EACA,WAAA;AACF","sourcesContent":[".container {\n  background-color: var(--base-0);\n  position: relative;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ChatFooter__container-a49986`
};
module.exports = ___CSS_LOADER_EXPORT___;
